import React from 'react'
import { Navigate as Redirect } from 'react-router'
import qs from 'qs'
import { get, isEmpty, omit } from 'lodash'

import exportActions from '../../actions/BenefitsSetsExports'
import indexActions from '../../actions/LargeGroupCustomBenefitsSets'
import BulkPublishLink from '../BenefitsSet/BulkPublishLink'
import { BenefitsSetIndex } from '../BenefitsSet/BenefitsSetIndex'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import connectIndex from '../../lib/connectIndex'
import withRouter from '../../lib/withRouter'
import exportCsvActions from '../../actions/BenefitsSetCsvExports'
import approvalStateDisplay from '../BenefitsSet/approvalStateDisplay'
import BooleanCellDisplayRenderer from '../common/BooleanCellDisplayRenderer'

export class LargeGroupCustomBenefitsSetIndex extends Component {
  static propTypes = {
    ...omit(BenefitsSetIndex.propTypes, 'productLine')
  }

  get bulkPublishButton() {
    const planCount = get(this.props.pagination, 'total', 0)

    if (planCount === 0 || isEmpty(this.queryParams)) {
      return null
    }

    return (
      <BulkPublishLink
        key="bulk-publish-link"
        planCount={planCount}
        queryParams={this.queryParams}
        productLine="large_group_custom"
      />
    )
  }

  get queryParams() {
    return qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
  }

  render() {
    const { benefitsSetCsvExport } = this.props
    if (benefitsSetCsvExport && benefitsSetCsvExport.created) {
      return (
        <Redirect
          push
          to={{ pathname: '/benefits_set_csv_exports' }}
        />
      )
    }

    return (
      <div>
        <BenefitsSetIndex
          {...this.props}
          name="Large Group Custom Benefits Set"
          columnsList={columnsList}
          includeBulkEditLink
          includeDiffSetLink
          includeSelectAll
          includeNewRecordLink
          includeCsvExportLink
          searchPlaceholder="Search by Name, Vericred ID, Customer, Document ID or DOR Ticket"
          searchColumns={['name', 'vericred_id', 'customer', 'document_id', 'dor_ticket']}
          actionLinks={[this.bulkPublishButton]}
          extraQueryParams={{ audience: ['Large Group Custom'] }}
          productLine="large_group_custom"
        />
      </div>
    )
  }
}

const columnsList = [
  { key: 'customer', label: 'Customer', filterable: true, optionsEnum: true },
  { key: 'dor_ticket', label: 'DOR Ticket', display: BenefitsSetIndex.showDORTicketLinkDisplay },
  { key: 'name', label: 'Name', display: BenefitsSetIndex.showLinkDisplay('/large_group_custom_benefits') },
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },
  { key: 'created_at', label: 'Created At', display: IndexComponent.dateTimeDisplay, filterable: true },
  {
    key: 'key_benefits_complete',
    label: 'Key Benefits Complete',
    filterable: true,
    display: BooleanCellDisplayRenderer,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'network_complete',
    label: 'Network Complete',
    filterable: true,
    display: BooleanCellDisplayRenderer,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'sbc_rejected',
    label: 'Non-SBC',
    filterable: true,
    display: BooleanCellDisplayRenderer,
    sortable: false,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'networks',
    label: 'Networks',
    sortable: false,
    display: BenefitsSetIndex.networksDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'network_unmapped_reason',
    label: 'Network Unmapped Reason',
    filterable: true,
    sortable: false,
    optionsEnum: true
  },
  {
    key: 'approval_state',
    label: 'Status',
    display: approvalStateDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  { key: 'updated_at', label: 'Last Updated At', display: IndexComponent.dateTimeDisplay },
  { key: 'last_updated_by_username', label: 'Last Updated By' }
]

const filters = [
  {
    key: 'customer',
    config: 'large_group_custom_benefits.customers'
  },
  {
    key: 'key_benefits_complete',
    options: [
      { value: 'true', text: 'Yes' },
      { value: 'false', text: 'No' }
    ]
  },
  {
    key: 'network_complete',
    options: [
      { value: 'true', text: 'Yes' },
      { value: 'false', text: 'No' }
    ]
  },
  {
    key: 'sbc_rejected',
    options: [
      { value: 'true', text: 'Yes' },
      { value: 'false', text: 'No' }
    ]
  },
  {
    key: 'needs_sbc_processing',
    options: [
      { value: 'true', text: 'Yes' },
      { value: 'false', text: 'No' }
    ]
  },
  {
    key: 'created_at',
    dateRangeField: true
  },
  {
    key: 'networks',
    options: [
      { value: 'true', text: 'Mapped' },
      { value: 'false', text: 'Not Mapped' }
    ]
  },
  {
    key: 'network_unmapped_reason',
    config: 'networks.network_unmapped_reason_options'
  },
  {
    key: 'approval_state',
    options: [
      { value: 'new', text: 'New' },
      { value: 'approved', text: 'Approved' },
      { value: 'rejected', text: 'Rejected' },
      { value: 'corrected', text: 'Corrected' },
      { value: 'amended', text: 'Amended' }
    ]
  },
  {
    key: 'publish_state',
    options: [
      { value: 'needs_publishing', text: 'Needs Publishing' },
      { value: 'failed_to_publish', text: 'Failed to publish' },
      { value: 'published', text: 'Published' },
      { value: 'unpublished', text: 'Unpublished' },
      { value: 'publishing', text: 'Publishing' }
    ]
  }
]

export default connectIndex(
  withRouter(LargeGroupCustomBenefitsSetIndex),
  'largeGroupCustomBenefitsSets',
  indexActions,
  filters,
  {
    benefitsSetPath: '/large_group_custom_benefits',
    includeCsvExportLink: true
  },
  [
    { action: exportActions.create.main, key: 'createBenefitsSetExport' },
    { action: exportActions.create.reset, key: 'resetCreateBenefitsSetExport' },
    { action: exportCsvActions.create.main, key: 'createBenefitsSetCsvExport' },
    { action: exportCsvActions.create.reset, key: 'resetCreateBenefitsSetCsvExport' }
  ],
  [
    { key: 'benefitsSetExport', reducer: 'benefitsSetsExports', action: 'create' },
    { key: 'benefitsSetCsvExport', reducer: 'benefitsSetCsvExports', action: 'create' }
  ]
)
